/**
 * @author Owais Liaquat Ali
 * @datetime Aug, 16th 2023
 */

// Const for Access Point Status
export const AccessPointStatusRequest: any = {
  Unassigned: 0, // Represents an unassigned access point
  Assigned: 1, // Represents an assigned access point
};

// Const for Unit Status
export const unitStatusRequest: any = {
  Vacant: 0, // Represents a vacant unit
  Occupied: 1, // Represents an occupied unit
};

// Const for User Types
export const UserTypeRequest: any = {
  'Property Manager Admin': 1, // Property manager with administrative privileges
  'Property Manager User': 2, // Property manager with regular user privileges
  'Installer Admin': 3, // Installer with administrative privileges
  'Installer User': 4, // Installer with regular user privileges
  'End User Admin': 5, // End user with administrative privileges
  'End User User': 6, // End user with regular user privileges
  Resident: 7, // Generic end user
  'EOL Tester': 8, // Tester for end of life scenarios
};

// Const for Activation State
export const ActivationStateRequest: any = {
  PENDING_ACTIVATION: 0, // Activation is pending
  ACTIVATED: 1, // Activation is complete
  PENDING_DEACTIVATION: 2, // Deactivation is pending
};

// Const for Device Status
export const DeviceStatusRequest: any = {
  Locked: 1, // Device is locked
  Unlocked: 2, // Device is unlocked
};

// Const for Battery Alarms
export const BatteryAlarmRequest: any = {
  'No battery alarm': 0, // No battery alarm
  'Low battery': 1, // Battery is low
  'Very low battery': 2, // Battery is very low
  'Too low to operate battery': 3, // Battery is too low to operate
};

// Const for Access Levels
export const AccessLevelRequest: Record<'Resident_Admin' | 'Resident', number> =
  {
    Resident_Admin: 1, // Administrative user access level
    Resident: 2, // Regular user access level
  };

// Const for Card Status
export const CardStatusRequest: any = {
  PENDING: 1, // Card status is pending
  ACTIVE: 2, // Card is active
  PENDING_BLOCKED: 3, // Card status is pending blocked
  BLOCKED: 4, // Card is blocked
};

// Const for Device Modes
export const DeviceModeRequest: any = {
  STATIC_STATE_LOCKED: 1, // Device is in static locked state
  STATIC_STATE_UNLOCKED: 2, // Device is in static unlocked state
};

// Const for Device States
export const DeviceStateRequest: any = {
  OFFLINE: 0, // Device is offline
  ONLINE: 1, // Device is online
};

// Const for Device Opened States
export const DeviceOpenedStateRequest: any = {
  CLOSED: 0, // Device is closed
  OPENED: 1, // Device is opened
};

export const UserStatusRequest: any = {
  PENDING: 1, // User is pending
  ACTIVE: 2,  // User is active
  PEDNDINGDELETION: 3,  // User is active
  FOB_ACCESS: 4,
  PENDING_ACCESS: 5,
};

